import { useQuery } from '@tanstack/react-query';

import { apiForms } from 'services/apiService';

export function useUserBioSummary(userId: string) {
  const { data, isLoading } = useQuery<string | null, Error>({
    queryKey: ['userBioSummary', userId],
    queryFn: async () => {
      // 1. Buscar todos os grupos/forms
      const groupsRes = await apiForms.get('/v1/groups/all');
      const groups = groupsRes.data;
      let foundForm = null;
      for (const group of groups) {
        foundForm = group.forms.find((f: any) => f.form_name === 'Biografia');
        if (foundForm) break;
      }
      if (!foundForm) return null;

      // 2. Buscar os campos do form
      const fieldsRes = await apiForms.get(`/v1/fields/${foundForm.id}`);
      const fields = fieldsRes.data;
      const targetField = fields.find(
        (field: any) => field.label === 'Conte-nos um pouco sobre sua TRAJETÓRIA profissional.'
      );
      if (!targetField) return null;

      // 3. Buscar submissão do usuário para esse campo
      const submissionsRes = await apiForms.get(
        `/v1/submissions/${targetField.id}?user_id=${userId}`
      );
      const submissions = submissionsRes.data;
      if (submissions.length > 0 && submissions[0].values.length > 0) {
        return submissions[0].values.map((v: any) => v.value).join(' ');
      }
      return null;
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 10, // 10 minutes - bio doesn't change frequently
  });

  return {
    bio: data || null,
    loading: isLoading,
  };
}
